import { VStack, useToast } from "@chakra-ui/react";
import React, { useCallback, useEffect, useState } from "react";
import SideNav from "../components/SideNav";
import { useNavigate } from "react-router-dom";
import cr from "../lib/request";
import KubuSpinner from "../components/KubuSpinner";
import { Cookies } from "typescript-cookie";
import SilabusUploadProccesses from "../components/courseComponents/SilabusUploadProccesses";

type Props = {
  active: number[];
  children: any;
  allowedRoles: string;
};

export default function AdminContainer({
  active,
  children,
  allowedRoles,
}: Props) {
  const [page, setPage] = useState(<KubuSpinner />);

  const navigate = useNavigate();
  const toast = useToast();

  const onSignout = useCallback(() => {
    const url = `api/logout`;
    cr.post(url)
      .then((r) => {
        navigate("/");
      })
      .catch((e) => {
        console.log(e);
      });
  }, [navigate]);

  useEffect(() => {
    setPage(<KubuSpinner />);

    const url = "api/logindata";
    cr.get(url)
      .then((r) => {
        if (r.status === 200) {
          if (r.data.data.is_public === 1) {
            Cookies.remove("user");
            onSignout();
            toast({
              title: "Tidak Ada Akses",
              description: "Anda tidak terdaftar untuk autentikasi ini",
              status: "error",
              duration: 10000,
              isClosable: true,
            });
          }
          if (r.data.data.roles[allowedRoles] || allowedRoles === "") {
            Cookies.set("user", JSON.stringify(r.data.data));
            setPage(children);
          } else {
            Cookies.remove("user");
            onSignout();
            toast({
              title: "Tidak Ada Akses",
              description: "Anda tidak terdaftar untuk autentikasi ini",
              status: "error",
              duration: 10000,
              isClosable: true,
            });
          }
        }
      })
      .catch((error) => {
        onSignout();
        Cookies.remove("user");
        console.log(error);
        toast({
          title: "Tidak Ada Akses",
          description: "Silahkan masuk terlebih dahulu",
          status: "error",
          duration: 10000,
          isClosable: true,
        });
        navigate("/");
      });
  }, [children, navigate, toast, allowedRoles, onSignout]);

  return (
    <VStack gap={0} align={"stretch"}>
      <SideNav active={active} />

      <SilabusUploadProccesses />

      <VStack
        minH={"100vh"}
        align={"stretch"}
        pt={"50px"}
        pl={"60px !important"}
        gap={0}
      >
        {page}
      </VStack>
    </VStack>
  );
}
